export default __webpack_public_path__ + "static/media/footer_bg.25c4d822.png";